var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c('lawyer-card', {
      attrs: {
        "code": item.code,
        "mouseOver": _vm.mouseOver,
        "data-aos": "fade-up",
        "data-aos-delay": [200, 100, 0][index % 3],
        "imageActive": `/images/lawyer/${item.code}.jpg`,
        "lang": _vm.lang
      }
    })], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }